// Shared 12-hour (AM/PM) date & time formatters, pinned to Central Time
// (America/Chicago), so times never render in 24-hour "military" format or in the
// viewer's local zone regardless of where the admin is.

const TZ = "America/Chicago";

export const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric",
    hour: "numeric", minute: "2-digit", hour12: true, timeZone: TZ,
  }) + " CT";
};

export const fmtTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: TZ }) + " CT";
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s).slice(0, 10));
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(s);
  if (isNaN(d.getTime())) return s;
  const opts = { month: "short", day: "numeric", year: "numeric" };
  if (!m) opts.timeZone = TZ;  // only shift zone for full timestamps, not bare dates
  return d.toLocaleDateString("en-US", opts);
};

// Convert a stored "HH:MM" (24h) clock string to "h:MM AM/PM". Passes through
// strings that already contain AM/PM or that aren't clock-like.
export const to12h = (t) => {
  if (!t) return t;
  if (/[ap]\.?m\.?/i.test(t)) return t;
  const m = /^\s*(\d{1,2}):(\d{2})/.exec(t);
  if (!m) return t;
  let h = parseInt(m[1], 10);
  const min = m[2];
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${min} ${ap}`;
};
